import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import config from "./config.js";
import { handleConsent as handleGtmConsent } from "../../consent-handlers/gtm.js";

/**
 * @param {CookieConsent.CookieValue} cookie
 */
const handleConsent = function (cookie) {
    handleGtmConsent(cookie);

    // [core³] Add your custom consent handlers here...
};

export default function () {
    if (window.DISABLE_COOKIE_CONSENT === true) return;

    window.addEventListener("load", () => {
        // Start cookie consent handler
        CookieConsent.run({
            onConsent: ({ cookie }) => handleConsent(cookie),
            onChange: ({ cookie }) => handleConsent(cookie),
            ...config,
        });

        // Create click event listener for the toggle button
        document
            .getElementById("cookie-consent-toggle")
            .addEventListener("click", () => CookieConsent.show(true));
    });
}
